var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93005 5.34773C10.8324 3.71742 13.1792 3.71742 14.0815 5.34773C14.1058 5.39165 14.1256 5.43728 14.141 5.48399L20.8123 17.5484C20.8169 17.5568 20.8215 17.5654 20.8258 17.574C21.3649 18.6388 20.5847 19.875 19.4166 19.875H4.5791C3.3965 19.875 2.64803 18.6201 3.16777 17.5782C3.17277 17.5681 3.17799 17.5582 3.18342 17.5484L9.93005 5.34773ZM12.6389 6.02469C12.3054 5.57702 11.5951 5.60774 11.3133 6.11686L4.58321 18.2876L4.58418 18.2895H19.4135L12.6823 6.1166C12.6657 6.0867 12.6513 6.05599 12.6389 6.02469Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0057 7.99158C12.4426 7.99158 12.7967 8.34651 12.7967 8.78433V14.3336C12.7967 14.7714 12.4426 15.1263 12.0057 15.1263C11.5689 15.1263 11.2148 14.7714 11.2148 14.3336V8.78433C11.2148 8.34651 11.5689 7.99158 12.0057 7.99158Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0057 17.5522C12.4426 17.5522 12.7967 17.1973 12.7967 16.7594C12.7967 16.3216 12.4426 15.9667 12.0057 15.9667C11.5689 15.9667 11.2148 16.3216 11.2148 16.7594C11.2148 17.1973 11.5689 17.5522 12.0057 17.5522Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineWarningTriangle);
export default __webpack_public_path__ + "static/media/line-warning-triangle.22263fa9621971e36e388fce2b31f524.svg";
export { ForwardRef as ReactComponent };